export default __webpack_public_path__ + "static/media/backed-web-bg.c891e509.webp";